module.exports = __webpack_public_path__ + "img/LogoDashboard-31.9ca78968.svg";